export default "__VITE_ASSET__4XT$zsk4__"